import createRefresh from 'react-auth-kit/createRefresh';
import axios from 'axios';

const refresh = createRefresh({
    interval: 30, // The time in min to refresh the Access token
    refreshApiCallback: async (param) => {

        // fetch data from api
        const options = {

        };
        const data = {
            refresh_token: param.refreshToken
        };

        // Dynamische URL basierend auf der Umgebung
        const baseURL = process.env.REACT_APP_ENV === 'development'
            ? `http://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`
            : `https://${process.env.REACT_APP_BACKEND_API_BASE_URI_ENV}`;


        try {
            const response = await axios.post(`${baseURL}/auth/refresh`,
                data,
                options
            );

            console.log("Refreshing")

            return {
                isSuccess: true,
                newAuthUserState: response.data.data,
                newAuthToken: response.data.token,
                newAuthTokenExpireIn: response.data.token_expires_in,
                newRefreshToken: response.data.refresh,
                newRefreshTokenExpiresIn: response.data.refresh_expires_in
            }
        }
        catch (error) {
            console.error(error);
            if (error.response.status === 401 && error.response.data.message === 'Invalid refresh token'){
                return {
                    isSuccess: false,
                    isTokenExpired: true
                }
            }
            if (error.response.status === 401 && error.response.data.message === 'Refresh token is expired. Please sign-in.') {
                return {
                    isSuccess: false,
                    isTokenExpired: true
                }
            }
        }
    }
})

export default refresh;